<template @change="handleChange">
  <transition name="fade">
    <div class="vue-modal" v-show="open">
      <transition name="drop-in">
          <div>
            <div class="vue-modal-inner" v-show="open" >
              <div
                class="vue-modal-content"
                style="font-size: 1.2em; text-align: center ;background-color: var(--form-color); color: var(--theme-text-main); border-radius: 15px; padding: 30px;"
              >
                <slot />
                <p class="h3 text-seccess fw-bold" v-if="showError">Error</p>
                <br />
                <table width="100%">
                  <tr>
                    <td></td>
                    <td></td>
                    <td width="200px">Please Fill</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr v-for="(part, index) in this.currencyVal" :key="part.value">
                    <td
                      v-if="index < 13"
                      style="width: 20%; padding-top: 3px; padding-right: 15px"
                    >
                      <label
                        v-if="part.value != 'Mobile'"
                        title="PartyLbl"
                        style="color: #fff"
                        >{{ part.value }}</label
                      >
                      <button
                        v-else
                        @click="this.showPopup = !this.showPopup"
                        class="btn btn-primary"
                      >
                        Mobile
                      </button>
                    </td>
                    <td></td>
                    <td
                      v-if="index < 13"
                      style="
                        width: 50%;
                        padding-top: 3px;
                        background-color: var(--form-color);
                      "
                      align="center"
                    >
                    <input
                      type="text"
                      style="
                        color: #000;
                        background-color: #e8f0fe;
                        text-align: center; border-radius: 10px;
                      "
                      :name="getCurrencyFldName(part.value)"
                      @focus="focusInput(part, $event)"
                      @input="addCurrencyToList($event)"
                      @blur="addCurrencyToList($event)"
                      size="10"
                      :value="focusedInput && focusedInput.value === part.value ? tempValue : formatCount(part.count)"
                      :disabled="
                        part.value === 'Mobile' ||
                        part.value === 'credit' ||
                        part.value === 'giftcard' ||
                        part.value === 'account'
                      "
                    />
                  </td>
                    <td></td>
                    <td
                      v-if="index < 13"
                      align="center"
                      style="width: 30%; padding-top: 3px"
                    >
                      <label
                        v-if="part.value == 'Mobile'"
                        title="PartyLbl"
                        v-text="calcCurrencyMult(part.value, total_mobile)"
                        style="color: #fff; font-size: 20; font-weight: 700"
                      >
                      </label>
                      <label
                        v-else-if="
                          part.value == 'credit' ||
                          part.value == 'giftcard' ||
                          part.value == 'account'
                        "
                        v-text="formatCount(part.count)"
                        style="color: #fff; font-size: 20; font-weight: 700"
                      >
                      </label>
                      <label
                        v-else
                        v-text="calcCurrencyMult(part.value, part.count)"
                        style="color: #fff; font-size: 20; font-weight: 700"
                      >
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">----------------------------------</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <button @click="saveCurrencyParts" class="btn btn-success">
                        Save
                      </button>
                    </td>
                    <td></td>
                    <td>
                      <button @click="close" class="btn btn-danger">Cancel</button>
                    </td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </div>
              <div class="col-sm-4"
                  style="position:fixed;width:250px;height:300px; min-height: 200px;left:0px;bottom:-80px;margin-left: -15px;margin-right: -10px;">
                  <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="true" />
              </div>
          </div>
      </transition>
    </div>
  </transition>

  <transition v-if="showPopup == true" name="fade">
    <div class="vue-modal" v-show="open">
      <transition name="drop-in">
        <div class="vue-modal-inner" v-show="open">
          <div
            class="vue-modal-content"
            style="font-size: 1.2em; text-align: center"
          >
            <slot />
            <p class="h3 text-seccess fw-bold" v-if="showError">Error</p>
            <br />
            <table width="100%">
              <tr v-for="part in allMobilePaymentProviders" :key="part.name">
                <td style="width: 60%; padding-top: 3px; padding-right: 15px">
                  <label title="PartyLbl" style="color: var(--theme-text-main)">{{
                    part.name
                  }}</label>
                </td>

                <td
                  style="
                    width: 50%;
                    padding-top: 3px;
                  "
                  align="center"
                >
                  <input
                    type="text"
                    style="
                      color: #000;
                      background-color: #e8f0fe;
                      text-align: center;
                      text-align: center; border-radius: 10px;
                    "
                    :name="part.name"
                    @focus="clearCurencyField($event)"
                    @blur="addCurrencyToList($event)"
                    @input="
                      updateCount(part, $event.target.value),
                        addCurrencyToList($event)
                    "
                    size="10"
                    v-model="part.count"
                  />
                </td>
                <td></td>
              </tr>

              <tr>
                <td colspan="5">----------------------------------</td>
              </tr>
              <tr>
                <td>
                  <button
                    @click="saveCurrencyParts_mobile"
                    class="btn btn-success"
                  >
                    Save
                  </button>
                </td>
                <td></td>
                <td>
                  <button
                    @click="this.showPopup = !this.showPopup"
                    class="btn btn-danger"
                  >
                    Cancel
                  </button>
                </td>
                <td></td>
              </tr>
            </table>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import numericpad from "@/components/SimpleKeyboard";

export default {
  name: "CloseCash",
  mixins: [commonServices],
  components: {
    numericpad
  },
  mounted() {
    this.getCurrencyParts();
    this.getAllMobilePaymentProviders();
  },

  data: function () {
    return {
      totalBoxAmount: 0,
      currencyParts: [],
      currencyVal: [],
      paymentData: [],
      mobilePaymentProviderJson: {},
      currencyItem: "",
      showError: false,
      total_mobile: 0,
      showPopup: false,
      focusedInput: null, // Track which input is focused
      tempValue: "" // Track the value being typed
    };
  },
  methods: {
    getCurrencyFldName(val) {
      return val.toString();
    },
    handleChange(event) {},
    clearCurencyField(event) {
      event.target.value = "";
    },
    focusInput(part, event) {
      this.focusedInput = part;
      this.tempValue = "";
      event.target.value = "";
    },
    onInput(key) {
      if (!this.focusedInput) return;
      
      if (key == 11) {
        this.tempValue = this.tempValue + "0";
      } else if (key < 10) {
        this.tempValue = this.tempValue + key;
      }
      
      // Update the currencyVal
      let tempCurrencyValues = this.currencyVal.filter(a => a.value.toLowerCase() === this.focusedInput.value.toLowerCase());
      if (tempCurrencyValues.length > 0) {
        tempCurrencyValues[0].count = this.tempValue;
      }
      
      // Recalculate total
      this.calculateTotalBoxAmount();
    },
    onDelete() {
      if (!this.focusedInput) return;
      
      this.tempValue = this.tempValue.slice(0, this.tempValue.length - 1);
      
      // Update the currencyVal
      let tempCurrencyValues = this.currencyVal.filter(a => a.value.toLowerCase() === this.focusedInput.value.toLowerCase());
      if (tempCurrencyValues.length > 0) {
        tempCurrencyValues[0].count = this.tempValue;
      }
      
      // Recalculate total
      this.calculateTotalBoxAmount();
    },
    onReset() {
      if (!this.focusedInput) return;
      
      this.tempValue = "";
      
      // Update the currencyVal
      let tempCurrencyValues = this.currencyVal.filter(a => a.value.toLowerCase() === this.focusedInput.value.toLowerCase());
      if (tempCurrencyValues.length > 0) {
        tempCurrencyValues[0].count = "0";
      }
      
      // Recalculate total
      this.calculateTotalBoxAmount();
    },
    calculateTotalBoxAmount() {
      let tempTotal = 0;
      this.currencyVal.forEach(function (a) {
        tempTotal = tempTotal + (parseFloat(a.value) || 0) * (parseFloat(a.count) || 0);
      });
      this.totalBoxAmount = tempTotal;
    },
    formatCount(count) {
      count = Math.round(count);
      return count.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    getpaymentnoncash: async function (datapassed) {
            let userId = localStorage.userId;
            this.mobilePaymentProviderJson.userId = userId;
            try {
                // let dataURL = this.apiURL + 'Orders/get_payment_info';
                // let response = await axios.post(dataURL, this.mobilePaymentProviderJson);
                // if (response.data.status === 'success') {
                 this.paymentData = datapassed;

                 let currencyVal = this.currencyVal
                 this.paymentData.forEach(function(a) {
                    if(a.payment_type == 'giftcard'){
                        const giftCard = currencyVal.find(item => item.value === 'giftcard');
                        giftCard.count = a.amount;
                    }
                    else if(a.payment_type == 'account'){
                        const giftCard = currencyVal.find(item => item.value === 'account');
                        giftCard.count = a.amount;
                    }
                    else if(a.payment_type == 'credit'){
                        const giftCard = currencyVal.find(item => item.value === 'credit');
                        giftCard.count = a.amount;
                    }
                    });

                    this.currencyVal = currencyVal;

                //}
            }
            catch (error) {
                console.log(error);
            }
            return this.allMobilePaymentProviders;
        },
    addCurrencyToList(event) {
      if (event.target.value) {
        let tempCurrencyValues = this.currencyVal.filter(function (a) {
          if (a.value.toLowerCase() === event.target.name.toLowerCase()) {
            return true;
          }
          return false;
        });

        if (tempCurrencyValues.length > 0) {
          tempCurrencyValues[0].value = event.target.name;
          tempCurrencyValues[0].count = event.target.value;
        } else {
          this.currencyVal.push({
            value: event.target.name,
            count: event.target.value,
          });
        }
      } else {
        event.target.value = "0";
      }
      let tempTotal = 0;
      this.currencyVal.forEach(function (a) {
        tempTotal = tempTotal + a.value * a.count;
      });
      this.totalBoxAmount = tempTotal;
    },
    updateCount(part, value) {
      part.count = parseFloat(value) || 0;
    },
    getAllMobilePaymentProviders: async function () {
      let appId = localStorage.appId;
      this.mobilePaymentProviderJson.appId = appId;
      try {
        let dataURL =
          this.apiURL + "MobilePaymentProviders/getAllMobilePaymentProviders";
        let response = await axios.post(
          dataURL,
          this.mobilePaymentProviderJson
        );
        if (response.data.status === "success") {
          this.allMobilePaymentProviders = response.data.results;
        }
      } catch (error) {
        console.log(error);
      }
      return this.allMobilePaymentProviders;
    },

    calculateTotalCash() {
      let total = this.currencyVal.reduce((sum, item) => {
        const value = parseFloat(item.value); // Convert value to a number
        const count = parseInt(item.count) || 0; // Convert count to a number

        // Only multiply if both value and count are valid numbers
        if (!isNaN(value) && !isNaN(count)) {
          return sum + value * count;
        }
        return sum;
      }, 0);

      // Return the total cash as an object
      return {
        value: "cash",
        count: total.toString(), // Convert total to string if needed
      };
    },
    getCurrencySummary() {
      let total = 0;

      // Calculate total cash
      this.currencyVal.forEach((item) => {
        const value = parseFloat(item.value);
        const count = parseInt(item.count) || 0;

        if (!isNaN(value) && !isNaN(count)) {
          total += value * count;
        }
      });

      const result = this.currencyVal.filter((item) => {
        const value = parseFloat(item.value);
        return isNaN(value); // Keep only non-numeric entries
      });

      result.push({ value: "cash", count: total.toString() }); // Ensure count is a string

      // Convert all entries to the same format
      return result.map((item) => ({
        value: item.value.toString(), // Ensure value is a string
        count: item.count.toString(), // Ensure count is a string
      }));
    },
    saveCurrencyParts: async function () {
      try {
        //Close Pos API
        let dataURL = this.apiURL + "Orders/closePos_payment_cls";
        let totalCash = this.calculateTotalCash();
        // console.log(totalCash);
        let updatedCurrencyVal = this.getCurrencySummary();
        // console.log(updatedCurrencyVal);
        let closePosJson = {
          appId: localStorage.appId,
          userId: localStorage.userId,
          currencyDetail: updatedCurrencyVal,
        };
        let response = await axios.post(dataURL, closePosJson);
        if (response.data.status === "success") {
          this.$emit("setCashDetail", this.currencyVal);
          this.currencyVal = [];
          this.close();
          //localStorage.clear();
        } else {
          if (response.data.status === "errorShift") {
            this.showAlert(response.data.msg);
    
          } else {
            this.showError = true;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    saveCurrencyParts_mobile() {
      // Calculate the total sum
      this.showPopup = !this.showPopup;
      //   console.log(this.allMobilePaymentProviders);
      // Calculate the total sum, ensuring all counts are numbers
      const totalSum = this.allMobilePaymentProviders.reduce((sum, part) => {
        return sum + (parseFloat(part.count) || 0);
      }, 0);
      this.total_mobile = totalSum;
    },
    calcCurrencyMult(value, count) {
      let ret = "0";
      if (value + "" === "Credit Card" || value + "" === "Mobile") {
        ret = this.formatNumber(parseFloat(count).toFixed(2) + "");
      } else {
        ret = this.formatNumber(parseFloat(value * count).toFixed(2) + "");
      }
      return ret;
    },
    getCurrencyParts: async function () {
      //console.log('appId',localStorage.appId);
      try {
        //Get Currency Parts API
        let dataURL = this.apiURL + "Orders/getCurrencyParts";
        let accountJson = { appId: "7" };
        let response = await axios.post(dataURL, accountJson);
        let tmpp = [];
        if (response.data.status === "success") {
          this.currencyParts = response.data.results;
          this.currencyParts.forEach(function (a) {
            tmpp.push({ value: a.value, count: 0 });
          });
          this.currencyVal = tmpp;
        } else {
          this.showError = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  props: {
    // open: Boolean,
    // paymentData: Array,
    open: {
      type: Boolean,
      required: true,
    },
  },
  setup(_, { emit }) {
    const close = () => {
      emit("close");
    };

    return { close };
  },
};
</script>
<style scoped>
*,
::before ::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.vue-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 100;
}
.vue-modal-inner {
  max-width: 500px;
  margin: 2rem auto;
}
.vue-modal-content {
  position: relative;
  background-color: var(--form-color); 
  color: var(--theme-text-main);
   border-radius: 15px; 
   padding: 30px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  background-clip: padding-box;
  border-radius: 1rem;
  padding: 1rem;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
  transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
  opacity: 0;
  transform: translateY(50px);
}
</style>
